import { CreativityContentData, FormCreativityContent, isFormCreativity, CreativityType } from '../types/banner';

const hasDateField = (creativity: CreativityContentData): creativity is FormCreativityContent<CreativityType> => {
  return isFormCreativity(creativity) && 'date' in creativity.config;
};

const sortByDateField = (
  a: FormCreativityContent<CreativityType>,
  b: FormCreativityContent<CreativityType>
): number => {
  if (!('date' in a.config) || !('date' in b.config)) {
    return 0;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const dateA = new Date(a.config.date as string);
  const dateB = new Date(b.config.date as string);

  const aIsPast = dateA < today;
  const bIsPast = dateB < today;

  if (aIsPast && !bIsPast) return 1;
  if (!aIsPast && bIsPast) return -1;

  return dateA.getTime() - dateB.getTime();
};

const sortByCreationDate = (a: CreativityContentData, b: CreativityContentData): number => {
  const dateA = new Date(a.createdAt ?? a.date);
  const dateB = new Date(b.createdAt ?? b.date);
  return dateB.getTime() - dateA.getTime();
};

export const sortBanners = (banners: CreativityContentData[]): CreativityContentData[] => {
  return [...banners].sort((a, b) => {
    if (hasDateField(a) && hasDateField(b)) {
      return sortByDateField(a, b);
    }
    return sortByCreationDate(a, b);
  });
};
